import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="feature-section">
      <div className="container">
        <div className="mb-5 pt-3 text-start">
          <h2 className="section-heading mt-3 text-center">Privacy Policy</h2>

          <p>
            This Privacy Policy is issued in accordance with the Digital
            Personal Data Protection Act, 2023 (“DPDP Act”) and governs the
            collection, use, storage, and processing of personal data by The
            Pilot Guide, operated by RightSource, with RightSource Aviation
            (RSA) as its subsidiary (collectively referred to as “we,” “us,” or
            “our”). By accessing or using The Pilot Guide mobile application,
            website, or related services, you (“User” or “Data Principal”)
            consent to the processing of your personal data as described in this
            Policy.
          </p>

          <p>
            We collect personal data such as your name, phone number, email
            address, photographs (if voluntarily provided), educational
            preferences, usage data, device information, payment-related
            metadata (processed via third-party gateways), and communication
            history solely for lawful purposes, including account creation,
            delivery of educational services, examination and airline
            preparation support, progress tracking, customer support, platform
            improvement, marketing communication, and compliance with legal
            obligations. Personal data is collected only to the extent
            necessary and processed on the basis of your explicit consent or
            for legitimate uses as permitted under the DPDP Act.
          </p>

          <p>
            By using The Pilot Guide, you consent to receiving service-related
            and promotional communications, including emails, messages, WhatsApp
            notifications, and phone calls. You may withdraw consent for
            promotional communication at any time, subject to applicable legal
            and operational limitations. Where users voluntarily submit
            photographs, testimonials, feedback, or success stories, you grant
            us consent to use such content for marketing, branding, educational,
            and promotional purposes across digital and offline platforms.
          </p>

          <p>
            We do not sell personal data. Data may be shared only with trusted
            third-party data processors (such as payment gateways, analytics
            providers, cloud storage services, and communication platforms)
            strictly for operational purposes, and such processors are
            contractually bound to comply with applicable data protection laws.
            Reasonable technical and organizational safeguards are implemented
            to protect personal data against unauthorized access, misuse,
            alteration, or loss.
          </p>

          <p>
            Under the DPDP Act, you have the right to access information about
            your personal data, request correction or erasure, withdraw consent,
            and raise grievances regarding data processing. Requests may be made
            by contacting us at info@thepilotguide.in , and we will respond
            within a reasonable time as prescribed under law. Personal data will
            be retained only for as long as necessary to fulfil its stated
            purpose or to comply with legal obligations, after which it will be
            securely deleted or anonymised.
          </p>

          <p>
            This Privacy Policy may be updated from time to time to reflect
            changes in law or business practices. Continued use of The Pilot
            Guide after such updates constitutes acceptance of the revised
            Policy. For any privacy-related concerns or grievance redressal,
            please contact info@thepilotguide.in
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
